module.exports = __webpack_public_path__ + "img/medium-biter-corpse.944f59b1.png";